var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"lg":"6","offset-lg":"2"}},[_c('my-ski-row-header',{staticClass:"pt-5",attrs:{"title":"Logger dig ud..."}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }